import Cashflow from '../../../components/Corporate/Cashflow/Cashflow'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import useModalShow from '../../../elements/Hooks/useModalShow'
import _ from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

function CashflowCont(props) {
  const [company, setCompany] = useState('')
  const { data: report, fetching, fetchURL } = useFetchURL(
    `foxxapi/cashflow/${company ? '?company=' + company : ''}`,
    [company],
  )

  const [startDate, setStartDate] = useState(moment())
  const [range, setRange] = useState([])
  const [dateRange, setDateRange] = useState(8)
  const [data, setData] = useState([])
  const { visible, onShow, onCancel } = useModalShow()
  const [modalData, setModalData] = useState({})

  // const currency = _.chain(data).map('currency').uniq().value().map(c => ({currency: c}))
  const currency = [
    { currency: 'AED' },
    { currency: 'AUD' },
    { currency: 'CNY' },
    { currency: 'EUR' },
    { currency: 'GBP' },
    { currency: 'MYR' },
    { currency: 'MZN' },
    { currency: 'PGK' },
    { currency: 'SGD' },
    { currency: 'USD' },
  ]

  useEffect(() => {
    if (!_.isEmpty(startDate) && !fetching && !_.isEmpty(report)) {
      /** create date range **/
      const range = Array(dateRange)
        .fill()
        .map((_, i) => startDate.clone().add(i, 'd'))
      setRange(range)

      console.log({ report })
      /** populate the table **/
      const tableDate = currency.map((c, i) => {
        const rowCells = range.map((d, j) => {
          const colAccessor = d.format('MMMMDD')
          let cell = report.find(
            r => r.date === d.format('YYYY-MM-DD') && r.currency === c.currency,
          )
          return { [colAccessor]: cell }
        })

        // flatten array
        const flat = Object.assign({}, ...rowCells)
        // add currency to it
        return { ...flat, currency: c.currency }
      })
      setData(tableDate)
    }
  }, [startDate, dateRange, fetching])

  const onChangeDate = (date, dateString) => {
    console.log(dateString)
    setStartDate(date)
  }

  const onChangeDay = i => {
    setStartDate(startDate.clone().add(i, 'd'))
  }

  return (
    <Cashflow
      {...{
        fetching,
        fetchURL,
        report,
        startDate,
        range,
        dateRange,
        currency,
        data,
        company,
        setCompany,
        onChangeDate,
        onChangeDay,
        visible,
        onShow,
        onCancel,
        modalData,
        setModalData,
      }}
    />
  )
}

export default CashflowCont
